import React from 'react';
import PropTypes from 'prop-types';

import ShowHideButton from '../../ShowHideButton/ShowHideButton';

import { useIntl } from 'react-intl';

import './ChargingStationsList.scss';

const ChargingStationsList = ({ chargingStations = [] }) => {
  const intl = useIntl();

  const mobile = window.innerWidth < 720;
  return (
    <div className="ChargingStationsList">
      <ShowHideButton
        buttonText={
          intl.formatMessage
            ? intl.formatMessage({
                id: 'chargingMap.showFullListOfStations',
                defaultMessage: 'full list of stations',
              })
            : 'full list of stations'
        }
      >
        <div className="charging-station-cards-container">
          <table className="station-table">
            {mobile ? null : <thead>
              <tr className="table-header">
                <th className="station-table-header">
                  {intl.formatMessage
                    ? intl.formatMessage({
                        id: 'chargingStationsList.station',
                        defaultMessage: 'Station',
                      })
                    : 'Station'}
                </th>
                <th className="station-table-header">
                  {intl.formatMessage
                    ? intl.formatMessage({
                        id: 'chargingStationsList.network',
                        defaultMessage: 'Network',
                      })
                    : 'Network'}
                </th>
                <th className="station-table-header">
                  {intl.formatMessage
                    ? intl.formatMessage({
                        id: 'chargingStationsList.address',
                        defaultMessage: 'Address',
                      })
                    : 'Address'}
                </th>
                <th className="station-table-header">
                  {intl.formatMessage
                    ? intl.formatMessage({
                        id: 'chargingStationsList.type',
                        defaultMessage: 'Type',
                      })
                    : 'Type'}
                </th>
                <th className="station-table-header">
                  {intl.formatMessage
                    ? intl.formatMessage({
                        id: 'chargingStationsList.phone',
                        defaultMessage: 'Phone',
                      })
                    : 'Phone'}
                </th>
              </tr>
            </thead>}
            <tbody>
              {chargingStations.map((station, index) => {
                const address = `${station.street_address}, ${station.city}, ${station.state} ${station.zip}`;

                return mobile ? (
                  <tr key={index} className="station-table-row">
                    <td className="station-table-cell">
                      <tr className="station-table-column">
                        {station.station_name}
                      </tr>
                      <tr className="station-table-column">
                        {station.ev_network}
                      </tr>
                      <tr className="station-table-column">{address}</tr>
                      <tr className="station-table-column">
                        {station.groups_with_access_code}
                      </tr>
                      <tr className="station-table-column">
                        {station.station_phone ? (
                          station.station_phone.split(' ').map((phone, idx) => (
                            <div key={idx}>
                              <a
                                href={`tel:${phone}`}
                                className="station-table-phone"
                              >
                                {phone}
                              </a>
                            </div>
                          ))
                        ) : (
                          <span>None</span>
                        )}
                      </tr>
                    </td>
                  </tr>
                ) : (
                  <tr key={index} className="station-table-row">
                    <td className="station-table-cell">
                      {station.station_name}
                    </td>
                    <td className="station-table-cell">{station.ev_network}</td>
                    <td className="station-table-cell">{address}</td>
                    <td className="station-table-cell">
                      {station.groups_with_access_code}
                    </td>
                    <td className="station-table-cell">
                      {station.station_phone ? (
                        station.station_phone.split(' ').map((phone, idx) => (
                          <div key={idx}>
                            <a
                              href={`tel:${phone}`}
                              className="station-table-phone"
                            >
                              {phone}
                            </a>
                          </div>
                        ))
                      ) : (
                        <span>None</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </ShowHideButton>
    </div>
  );
};

ChargingStationsList.propTypes = {
  chargingStations: PropTypes.array,
};

export default ChargingStationsList;
